

























import { Component, PropSync, Vue } from "vue-property-decorator";
import { ValidationProvider, extend } from "vee-validate";
import { size, required } from "vee-validate/dist/rules";

extend("size", {
  ...size,
  message: (fieldName, placeholders) => {
    return `Plik musi być mniejszy niż ${placeholders?.size / 1024} MB`;
  }
});

extend("file", {
  ...required,
  message: "Proszę wybrać plik"
});

@Component({
  components: {
    ValidationProvider
  }
})
export default class AttachmentUploader extends Vue {
  @PropSync("index", { type: Number }) syncedIndex!: number;
  @PropSync("file", { type: File }) syncedFile!: File;
  private provider!: InstanceType<typeof ValidationProvider>;

  mounted() {
    this.provider = this.$refs.provider as InstanceType<
      typeof ValidationProvider
    >;
  }

  private async onFileChanged(e: InputEvent) {
    const { valid } = await this.provider.validate(e);

    if (valid) {
      const files = (e.target as HTMLInputElement).files;
      if (files !== null) {
        const file = files[0];
        if (file !== undefined) {
          this.syncedFile = file;
        }
      }
    }
  }

  get fileName() {
    if (this.syncedFile !== undefined) return this.syncedFile.name;
    else return "...";
  }
}
